export const DATATABLE_CUSTOM_STYLES = {
  headRow: {
    style: {
      backgroundColor: "rgba(107, 114, 128, 0.2)",
    },
  },
  headCells: {
    style: {
      color: "#1f2937",
      fontSize: "14px",
      fontWeight: "bold",
      textAlign: "center",
      justifyContent: "center",
      padding: "7px",
    },
  },
  cells: {
    style: {
      color: "#4b5563",
      padding: "7px",
      textAlign: "center",
      justifyContent: "center",
    },
  },
  rows: {
    style: {
      "&:nth-child(odd)": {
        backgroundColor: "rgba(209, 213, 219, 0.2)", // Light grey for odd rows
      },
      "&:nth-child(even)": {
        backgroundColor: "white", // White for even rows
      },
    },
    highlightOnHoverStyle: {
      backgroundColor: "rgba(209, 213, 219, 0.4)",
      textAlign: "center",
    },
  },
};
export const MESSAGES_DATATABLE_CUSTOM_STYLES = {
  headRow: {
    style: {
      backgroundColor: "rgba(107, 114, 128, 0.2)",
    },
  },
  headCells: {
    style: {
      color: "#1f2937",
      fontSize: "14px",
      fontWeight: "bold",
      textAlign: "center",
      justifyContent: "center",
      padding: "7px",
    },
  },
  cells: {
    style: {
      color: "#4b5563",
      padding: "7px",
      textAlign: "center",
      justifyContent: "center",
    },
  },
};
// export const DATATABLE_FOR_STICKY_COLS = {
//   headRow: {
//     style: (col, index) => ({
//       position: "sticky",
//       top: 0,
//       zIndex: 4,
//       backgroundColor: "#f8f9fa",
//       ...(index === 0 && { left: "0px" }),
//       ...(index === 1 && { left: "70px" }),
//     }),
//   },

//   cells: {
//     style: {
//       padding: "10px",
//       textAlign: "center",
//       justifyContent: "center",
//     },
//   },
// };
